export default __webpack_public_path__ + "static/media/handsfree-shopping.inline.f21b3f15.svg";